export const authenticatedSession = (state) => Boolean(state?.auth?.user && state.auth.isAuthenticated && !state.auth.loading)

export const syncCardVisible = (state) => {
  if (!authenticatedSession(state)) return false
  const offline = state.offline || {}
  const pending = (offline.outboxItems || []).some((item) => item.status !== "synced")
  return !offline.isOnline || pending
}

export async function checkSyncResponse(response) {
  if (response.ok) return response
  const payload = await response.json().catch(() => ({}))
  const details = (Array.isArray(payload.errors) ? payload.errors : []).map((entry) =>
    typeof entry === "string" ? entry : [entry.path || entry.field, entry.msg || entry.message].filter(Boolean).join(": "))
  const error = new Error([payload.message || `Server returned ${response.status}`, ...details].join(". "))
  error.status = response.status
  throw error
}

export const providedIds = (item) => {
  const type = item.type || item.meta?.requestType
  if (type === "site-create") return [`offline-site-${item.clientId}`, item.clientId]
  if (type === "report-create") return [`offline-report-${item.clientId}`, item.clientId]
  if (type === "file-upload") return [item.clientId, `pending_${item.clientId}`]
  if (type?.endsWith("-create") || type === "file-clone") return [item.meta?.entityId, item.meta?.clientId]
  return []
}

export const dependentIds = (item) => {
  let body = {}
  try { body = JSON.parse(item.body || "{}") } catch {}
  return [item.siteId, item.metadata?.siteId, item.metadata?.reportId, item.metadata?.entityId,
    item.meta?.parentEntityId, item.meta?.reportId, body.siteId, body.reportId, body.observationId,
    body.workId, body.entityId, item.meta?.entityId].filter(Boolean)
    .filter((id) => !providedIds(item).includes(id))
}

// Stable dependency order preserves edits to each record while ensuring its
// site/report/work/observation and image creation complete before dependents.
export function orderSyncItems(items) {
  const remaining = [...items]
  const ordered = []
  while (remaining.length) {
    const index = remaining.findIndex((item) => !dependentIds(item).some((id) =>
      remaining.some((parent) => parent !== item && providedIds(parent).includes(id))))
    ordered.push(...remaining.splice(index < 0 ? 0 : index, 1))
  }
  return ordered
}
